import axios, { AxiosError } from 'axios';

function addToRetryList(callback: any) {
  failedRequests.push(callback);
}
async function retryFailedRequests(newAccessToken: string) {
  for (const request of failedRequests) {
    await request(newAccessToken);
  }
  failedRequests = [];
}

let isFetchingNewAccessToken = false;
let failedRequests: any[] = [];

export type AccessTokenProvider = () => Promise<{
  accessToken: string;
}>;

export type OnAccessTokenProviderError = (error: Error) => void;

// interceptor: on axios error
export default async function authInterceptor(
  error: AxiosError,
  accessTokenProvider?: AccessTokenProvider,
  onAccessTokenProviderError?: OnAccessTokenProviderError,
): Promise<unknown> {
  if (error.response && error.response.status === 401 && accessTokenProvider) {
    const retryOriginalRequest = new Promise(resolve => {
      // clone the error request and add to retry list
      // on retry the auth header is replaced with refreshed-accessToken
      addToRetryList((accessToken: string) => {
        error.config.headers['x-api-key'] = 'bearer ' + accessToken;
        resolve(axios(error.config));
      });
    });

    if (!isFetchingNewAccessToken) {
      isFetchingNewAccessToken = true;
      try {
        const { accessToken } = await accessTokenProvider();
        await retryFailedRequests(accessToken);
      } catch (providerError) {
        if (onAccessTokenProviderError) {
          onAccessTokenProviderError(providerError); // invoke error handler
        }
        throw error;
      } finally {
        isFetchingNewAccessToken = false;
      }
    }
    return retryOriginalRequest;
  }
  throw error;
}
